import { CSS, styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";

export const TableContainer = styled("div", {
  display: "block",
  whiteSpace: "nowrap",
  overflowX: "auto",
  overflowY: "hidden",
  maxW: "100%",
});

export const Table = styled("table", {
  fontVariantNumeric: "lining-nums tabular-nums",
  borderCollapse: "collapse",
  width: "100%",
});
export const Thead = styled("thead", {});
export const Tbody = styled("tbody", {});
export const Tr = styled("tr", {});

const cellStyles = {
  h: 40,
  minH: 40,
  textAlign: "left",
  fontScale: "sm",
  py: 4,
  px: 8,
  borderBottom: `1px solid ${colors.outline}`,
  "&:where(:first-child)": {
    pl: 16,
  },
  "&:last-child": {
    pr: 16,
  },
} satisfies CSS;

export const Th = styled("th", { ...cellStyles, fontScale: "xs", color: colors.text2, weight: 500, py: 12 });
export const Td = styled("td", cellStyles);
